import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import AppointmentTypeButton from './AppointmentTypeButton.js';

const AppointmentTypeButtonContainer = (_param)=>{
    var { appointmentType , toolTip , onClick , onClickToolTip  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointmentType",
        "toolTip",
        "onClick",
        "onClickToolTip"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>{
        const { name , description , duration  } = appointmentType;
        const durationLabel = duration.amount > 0 ? `${duration.amount} ${getLabel(`appointments.shortTimeUnits.${duration.unit.toLowerCase()}`)}` : '';
        return {
            name,
            description: `${durationLabel}${durationLabel.length && (description === null || description === void 0 ? void 0 : description.length) ? ' · ' : ''}${description !== null && description !== void 0 ? description : ''}`
        };
    }, [
        getLabel,
        appointmentType
    ]);
    const onClickHandler = React.useCallback(()=>onClick(appointmentType)
    , [
        onClick,
        appointmentType
    ]);
    const onClickToolTipHandler = React.useCallback(()=>{
        if (!toolTip || !onClickToolTip) {
            return;
        }
        onClickToolTip(toolTip);
    }, [
        onClickToolTip,
        toolTip
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentTypeButton, swcHelpers.extends({}, rest, {
        price: appointmentType.price,
        labels: labels,
        toolTip: toolTip,
        onClick: onClickHandler,
        onClickToolTip: onClickToolTipHandler
    }));
};

export { AppointmentTypeButtonContainer as default };
//# sourceMappingURL=AppointmentTypeButtonContainer.js.map
